(() => {
  if (window.exploreContinuousInit) return;
  window.exploreContinuousInit = true;

  document.querySelectorAll('.explore-section').forEach(initExploreMarquee);

  function initExploreMarquee(section) {
    const marquee = section.querySelector('.explore-marquee');
    const track = section.querySelector('.explore-track');
    const speed = parseFloat(marquee.dataset.speed) || 120;
    const originalItems = [...track.children];

    if (originalItems.length === 0) return;

    // Triplicate the items so the strip always has enough content to loop seamlessly.
    track.innerHTML = '';
    for (let i = 0; i < 3; i++) {
      originalItems.forEach((item) => track.appendChild(item.cloneNode(true)));
    }

    function measureAndAnimate() {
      const setCount = track.children.length / 3;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      let setWidth = 0;

      for (let i = 0; i < setCount; i++) {
        const item = track.children[i];
        const marginRight = parseFloat(getComputedStyle(item).marginRight) || 0;
        // Include the flex "gap" after every card - this was missing before, which made
        // the loop distance land short and produced the jump/"blink" once per lap.
        setWidth += item.offsetWidth + marginRight + gap;
      }

      track.style.setProperty('--distance', -setWidth + 'px');
      track.style.setProperty('--duration', setWidth / speed + 's');

      // Restart the animation cleanly with the freshly measured values.
      track.classList.remove('moving');
      void track.offsetWidth; // force reflow
      track.classList.add('moving');
    }

    // Only measure once every image has settled (loaded or failed), otherwise widths
    // are wrong and the loop point drifts.
    const images = track.querySelectorAll('img');
    let settledCount = 0;
    function onImageSettled() {
      settledCount++;
      if (settledCount === images.length) measureAndAnimate();
    }
    if (images.length === 0) {
      measureAndAnimate();
    } else {
      images.forEach((img) => {
        if (img.complete) {
          onImageSettled();
        } else {
          img.addEventListener('load', onImageSettled, { once: true });
          img.addEventListener('error', onImageSettled, { once: true });
        }
      });
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      track.classList.remove('moving');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measureAndAnimate, 150);
    });

    // ---- Pause on hover + drag-to-scroll ----
    let isHovering = false;
    let isDragging = false;
    let startX = 0;
    let startLeft = 0;

    function syncPlayState() {
      track.style.animationPlayState = (isHovering || isDragging) ? 'paused' : 'running';
    }

    marquee.addEventListener('mouseenter', () => {
      isHovering = true;
      syncPlayState();
    });

    marquee.addEventListener('mouseleave', () => {
      isHovering = false;
      if (isDragging) {
        isDragging = false;
        marquee.classList.remove('grabbing');
      }
      syncPlayState();
    });

    marquee.addEventListener('mousedown', (e) => {
      isDragging = true;
      marquee.classList.add('grabbing');
      startX = e.pageX;
      startLeft = track.getBoundingClientRect().left;
      syncPlayState();
    });

    document.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      marquee.classList.remove('grabbing');
      syncPlayState();
    });

    marquee.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const delta = e.pageX - startX;
      track.style.transform = `translateX(${startLeft + delta}px)`;
    });
  }
})();